<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-6">
        <p class="p-2">Data Aktif User {{iduser}}: </p>
        <select class='form-control' v-model="iduser" style="width:300px;">
          <option v-for="(item, index) in listuser" :key="index+'listuser'" :value="item.id">{{item.username}}</option>
        </select>
        <hr>
        <button type="button" @click="updateuser" class="btn btn-sm btn-primary  ">Update User</button>
      </div>
    </div>
    <div class="p-4">
      <div v-for="(item, index) in listMenu" :key="index+'listmenu'">
        <p class="font-semibold p-2">{{item.group}}</p>
        <button type="button" class="btn btn-sm btn-dark ml-2 text-lg"
        v-for="(item2, index2) in item.menu" :key="index2+'menus'"
        @click="$router.push(item2.link)"
        ><span class="typcn typcn-cog"></span> {{item2.name}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import autophp from '@/plugins/autophp';
import axios from 'axios'
let sdb = new autophp();
export default{
  layout:'app_admin',
  methods: {
    updateuser(){
      sdb.collection('app_portofolio_aktif',false).doc().set({id:1,user:this.iduser}).then(res=>{
          sdb.alert('berhasil update!');
      })
    },
    getuseraktif(){
      sdb.collection("app_portofolio_aktif",false).doc().select(`select * from app_portofolio_aktif where id='1'`).then(res => {
        this.iduser=res[0].user
        this.$forceUpdate();
      });
    },
    getUser(){
      sdb.collection("tbuser",false).doc().select(`select * from tbuser`).then(res => {
          console.log(res);
          this.listuser=res;
          this.$forceUpdate();
      });
    }
  },
  mounted() {
    this.getUser();
    this.getuseraktif();
  },
  data(){
    return{
      listuser:[

      ],
      iduser:'',
     listMenu:[
         {
          group:'About/Tentang',
          icon:'dropbox',
          level:['Admin'],
          menu:[
                {
                    name:"About",
                    link:'/admin/about',
                    level:['Admin'],
                    icon:'user'
                },
                {
                    name:"Pengalaman",
                    link:'/admin/about/pengalaman',
                    level:['Admin'],
                    icon:'user'
                },
                {
                    name:"Pendidikan",
                    link:'/admin/about/pendidikan',
                    level:['Admin'],
                    icon:'user'
                },
                
                 {
                    name:"Service",
                    link:'/admin/about/service',
                    level:['Admin'],
                    icon:'user'
                },
          ]
        },
         {
          group:'Portofolio',
          icon:'dropbox',
          level:['Admin'],
          menu:[
                {
                    name:"Skill",
                    link:'/admin/portofolio/skill',
                    level:['Admin'],
                    icon:'user'
                },
                {
                    name:"Sub SKill",
                    link:'/admin/portofolio/subskill',
                    level:['Admin'],
                    icon:'user'
                },
                 {
                    name:"Activity",
                    link:'/admin/portofolio/activity',
                    level:['Admin'],
                    icon:'user'
                },
              //  {
              //       name:"Stack",
              //       link:'/admin/portofolio/stack',
              //       level:['Admin'],
              //       icon:'user'
              //   },
          ]
        },
        {
          group:'Project',
          icon:'dropbox',
          level:['Admin'],
          menu:[
                {
                    name:"Project",
                    link:'/admin/project',
                    level:['Admin'],
                    icon:'user'
                },
                 {
                    name:"Kategori",
                    link:'/admin/project/kategori',
                    level:['Admin'],
                    icon:'user'
                },
          ]
        },
         {
          group:'Sertifikat',
          icon:'dropbox',
          level:['Admin'],
          menu:[
                {
                    name:"Sertifikat",
                    link:'/admin/sertifikat',
                    level:['Admin'],
                    icon:'user'
                },
                 {
                    name:"Award",
                    link:'/admin/sertifikat/award',
                    level:['Admin'],
                    icon:'user'
                },
                 {
                    name:"Seminar",
                    link:'/admin/sertifikat/seminar',
                    level:['Admin'],
                    icon:'user'
                },
          ]
        },
        {
          group:'Layout',
          icon:'dropbox',
          level:['Admin'],
          menu:[
                {
                    name:"Layout",
                    link:'/admin/layout',
                    level:['Admin'],
                    icon:'user'
                },
          ]
        },
      ]
    }
  }
}
</script>